// The profile-privacy policy, in one place.
//
// A profile's `privacy_settings` (owned by that user) decides which allowlisted
// fields other people may see. The convention for gated legacy profiles is
// "visible unless explicitly turned off". Phone numbers never cross this seam;
// a private Rolodex entry may still show the phone saved by its owner.
//
// Every renderer (detail panel, path card, graph tooltip, edit views) goes
// through here instead of re-deciding the rule inline.

import {
  PROFILE_PRIVACY_FLAGS,
  isProfileFieldPublished,
  publishedProfileValue,
} from "./profilePublication";

/** Compatibility name retained for existing render modules. */
export const PRIVACY_FLAG = PROFILE_PRIVACY_FLAGS;

/** Is `field` part of this profile's permitted public projection? */
export function isVisible(profile, field) {
  return isProfileFieldPublished(profile, field);
}

/** The field's value if visible, otherwise undefined. */
export function fieldValue(profile, field) {
  return publishedProfileValue(profile, field);
}

/**
 * First visible, non-empty field from a priority list — the primitive behind
 * subtitles ("show role, else industry, else school").
 */
export function firstVisible(profile, fields) {
  for (const field of fields) {
    const value = fieldValue(profile, field);
    if (value) return value;
  }
  return null;
}
